import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
import { SharedModule } from '@callcenter/shared/shared.module';
import { GlobalComponentsModule } from '@global_components/global-components.module';


@NgModule({
  declarations: [ReportsComponent],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    SharedModule,
    GlobalComponentsModule
  ]
})
export class ReportsModule { }
